<template>
  <div class="content">
    <p class="ability">Ability</p>
    <div class="row">
      <div class="icons">
        <i class="icon-left"></i> <i class="icon-right"></i>
      </div>
      <p class="small">To Transfer</p>
      <p class="subtitle">With Milford Adams</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "logo",
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Exo+2:ital,wght@1,800;1,900&display=swap");
@import url("../assets/fonts.css");

* {
  margin: 0;
}

.content {
  transform: scale(1.5);
  transform-origin: 0 0;
  position: absolute;
  margin-top: -15px;
  left: 0;
}

.subtitle {
  color: #4d94ff;
  padding-left: 100px;
}

p {
  font-family: "Exo 2", sans-serif;
  font-weight: 900;
  font-style: italic;
  color: #ff6600;
}

.ability {
  font-size: 80px;
}

.small {
  font-size: 50px;
  padding-left: 60px;
  display: inline-block;
}

.row {
  position: relative;
  margin-top: -15px;
}

.icons {
  position: absolute;
  top: 0;
  left: 0;
  height: 60px;
  margin-left: -10px;
}

.icon-left,
.icon-right {
  display: inline-block;
  font-size: 35px;
  color: #4d94ff;
  transition: all 1s ease-in-out;
}

.icon-left {
  position: absolute;
  top: 0px;
  left: 0px;
}

.icon-right {
  position: absolute;
  bottom: 0px;
  left: 25px;
}

.content:hover .icon-left {
  transform: translate(-20px, 0);
  opacity: 0;
}

.content:hover .icon-right {
  transform: translate(20px, 0);
  opacity: 0;
}
</style>
